import * as React from "react";
import "./grid.scss";

type Props = {};
export const Grid: React.FC<Props> = props => (
  <div className={"grid"}>{props.children}</div>
);
